<template>
  <div>
    <b-table
      striped
      hover
      :items="items"
      :fields="fields"
      :busy="loading"
    >
      <template v-slot:table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template v-slot:cell(status)="data">
        <span :class="data.value == 'ACTIVE' ? 'active' : 'inactive'">{{
          data.value
        }}</span>
      </template>
      <template v-slot:cell(actions)="row">
        <b-button
          size="sm"
          @click="
            $router.push({
              name: 'MemberHome',
              params: { id: row.item.id },
            })
          "
          class="mr-1"
          variant="primary"
        >
          <i class="fas fa-cog"></i> Manage
        </b-button>
      </template>
    </b-table>
  </div>
</template>
<script>
export default {
  props: { memberResult: Array },
  data() {
    return {
      fields: [
        "cardid",
        "firstname",
        "lastname",
        "nickname",
        "email",
        "phone",
        "status",
        "actions"
      ],
      items: null,
      loading: false
    };
  },
  computed: {},
  mounted() {
    this.items = this.memberResult;
    //console.log(this.memberResult);
    /*
    //console.log(this.memberResult);
    var resultArr = [];
    for (var i = 0; i < this.memberResult.length; i++) {
      let member = this.memberResult[i];
      let memberObj = {
        id: member.id,
        name: member.name,
        email: member.email,
        phone: member.phone,
      };
      resultArr.push(memberObj);
      //console.log(this.memberResult[i].email);
    }
    this.items = resultArr; */
  },
  methods: {
    checkinClick(item) {
      //to="{ name: 'MemberInfo' }"
      //console.log("Member " + item.id + " Checked In");
    }
  }
};
</script>
<style scoped>
.active {
  color: green;
  font-weight: bold;
}
.inactive {
  color: red;
  font-weight: bold;
}
</style>
